import { render, staticRenderFns } from "./VerGerencia.vue?vue&type=template&id=60cee6d5&"
import script from "./VerGerencia.vue?vue&type=script&lang=js&"
export * from "./VerGerencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports